export enum EtatValidationPlanning {
    NON_VALIDE,
    ATTENTE_VALIDATION,
    ATTENTE_MODIFICATION,
    VALIDE
  }